import Vue from 'vue'
import VueRouter from 'vue-router'
import lecturerRoutes from './lecturer'
import studentRoutes from './student'
import adminRoutes from './admin'
import store from '@/store/'

Vue.use(VueRouter)

const publicRoutes = [
  {
    path: '/chat/direct/:userId',
    name: 'DirectChatRoom',
    component: () => import('@/views/Chat/Room/'),
    meta: {
      title: 'Chat'
    }
  },
  {
    path: '/chat/:room',
    name: 'ChatRoom',
    component: () => import('@/views/Chat/Room/'),
    meta: {
      title: 'Chat'
    }
  },
  {
    path: '',
    component: () => import('@/views/Layouts/MiddleBox'),
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import('@/views/Login/'),
        meta: {
          public: true,
          title: 'Zaloguj się'
        }
      },
      {
        path: 'przypomnij-haslo',
        component: () => import('@/views/PasswordReset/Remind/'),
        meta: {
          public: true,
          title: 'Przypomnij hasło'
        }
      },
      {
        path: 'ustaw-haslo/:uid/:token',
        name: 'PasswordResetFinish',
        component: () => import('@/views/PasswordReset/Finish/'),
        meta: {
          public: true,
          title: 'Ustaw hasło'
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [...publicRoutes, ...adminRoutes, ...lecturerRoutes, ...studentRoutes]
})

const routeGuard = async (to, from, next) => {
  const publicRoute = to.meta.public

  document.title = to.meta.title
    ? `${to.meta.title} — Germanicus`
    : 'Germanicus'

  let userType = store.state.userInfo.user_type

  if (publicRoute) {
    next()
    return
  }

  if (!publicRoute && !userType) {
    Vue.prototype.$notification.error({
      message:
        'Ten widok jest dostępny tylko dla zalogowanych użytkowników. Zaloguj się.'
    })
    next({ name: 'Login', query: { next: to.path } })
    return
  }

  const allowedRoute = Vue.options.methods.routeForUser(to, userType)
  if (!allowedRoute) {
    Vue.prototype.$notification.error({
      message:
        'Nie masz uprawnień, aby przejść na tę podstronę. Zaloguj się na właściwie konto.'
    })
    next({ name: 'Login' })
    return
  }

  next()
}

router.beforeEach(routeGuard)

export default router
